import { SimpleGrid, useBreakpointValue } from '@chakra-ui/react';
import { AnalyticsEventProps } from '../common/libs/googleAnalytics';
import ArticleSummary, { Props as ArticleSummaryProps } from './ArticleSummary';

export type { ArticleHeader } from './ArticleSummary';

function useLayoutType(isMobile = false): ArticleSummaryProps['layoutType'] {
  const defaultBreakpoint = isMobile ? undefined : 'sm';
  return useBreakpointValue(
    {
      base: 'horizontal',
      sm: 'vertical',
    },
    defaultBreakpoint,
  );
}

// SimpleGridのカラム数 [base, sm, md] の順番で指定する
type ResponsibleColumnNumbersType = [number, number, number];

const defaultColumns: ResponsibleColumnNumbersType = [1, 2, 3];

export const specialPageRegularColumns: ResponsibleColumnNumbersType = [
  1, 2, 2,
];

export default function ArticlesGrid({
  articles,
  isMobile = true,
  gaEventLabel,
  additionalGaEvent,
  responsibleColumns = defaultColumns,
  onShowThumbnail,
  onClick,
}: {
  articles: ArticleSummaryProps[];
  isMobile?: boolean;
  gaEventLabel?: string | ((article: ArticleSummaryProps) => string); // articleSummaryのpropsから記事ごとのgaEventLabelを生成する関数を渡せる
  additionalGaEvent?: AnalyticsEventProps;
  responsibleColumns?: ResponsibleColumnNumbersType;
  onShowThumbnail?: (articleId: string) => void;
  onClick?: (articleId: string) => void;
}) {
  const layoutType = useLayoutType(isMobile);

  return (
    <SimpleGrid columns={responsibleColumns} spacing={4} w="full">
      {articles.map((article) => (
        <ArticleSummary
          key={`${article.articleId}-${article.status}`}
          {...article}
          layoutType={layoutType}
          gaEventLabel={
            gaEventLabel &&
            (typeof gaEventLabel === 'string'
              ? gaEventLabel
              : gaEventLabel(article))
          }
          additionalGaEvent={
            additionalGaEvent && {
              ...additionalGaEvent,
              label: `${article.articleId}${additionalGaEvent.label || ''}`,
            }
          }
          onShowThumbnail={onShowThumbnail}
          onClick={onClick}
        />
      ))}
    </SimpleGrid>
  );
}
